import Cookies from 'js-cookie'
import Config from '@/settings'

const TokenKey = Config.TokenKey

export function getToken() {
  return Cookies.get(TokenKey)

  // return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ3bGciLCJleHAiOjE3NDU0NTQ0NDcsInVzZXIiOiJDM2pkcm8yWkZSaU5qbmRnVlRhbUh1dlBFLVhWc05ScUtCdlAxTFVVbDZCRWFKWUJhcE40RTdJZERhbllLZGlPVS1HTWk5NGxiTzVhRDFwX2Y0NGdzWlI1YmZ5RUd6TUJpcGhESXk3anFDWWhzSEVGUmtwVHpRT0k5QzZsUVhKTCJ9.r_SbQt_J6dxOprZIoGObG7aw4eq-AKOfTlHt1H4VT_0'
}
export function setToken(token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  } else return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export const localSave = (key, value) => {
  localStorage.setItem(key, value)
}

export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}



// WEBPACK FOOTER //
// ./src/utils/auth.js